import { useDispatch, useSelector } from 'react-redux';

import {
  Popover,
  PopoverTrigger,
  Button,
  PopoverButtonGroup,
  Portal,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
} from '@frontend/components';

import { groupMemberChangeUserGroup } from 'modules/common/userGroupManagement/data/actions';

import { getAvailableGroupMembers } from 'store/session/selectors';

type ToggleState = React.Dispatch<React.SetStateAction<boolean>>;

type GroupMember = {
  id: number;
  group: {
    id: number;
    businessName: string;
  };
};

type ActionSwitchGroupPopoverProps = {
  children: React.ReactNode;
  toggleOpen: ToggleState;
  isOpen: boolean;
  nextUrl: string;
  groupId: number;
};

const ActionSwitchGroupPopover = ({
  children,
  toggleOpen,
  isOpen,
  nextUrl,
  groupId,
}: ActionSwitchGroupPopoverProps) => {
  const dispatch = useDispatch();

  const availableGroupMembers = useSelector(getAvailableGroupMembers);

  const requestedGroupMember: GroupMember | undefined = (
    availableGroupMembers as GroupMember[]
  ).find((groupMember: GroupMember) => groupMember.group.id === groupId);

  const handleSwitchAndRedirect = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    if (requestedGroupMember) {
      dispatch(
        groupMemberChangeUserGroup.request({
          groupMemberId: requestedGroupMember.id,
          nextUrl,
        }),
      );
    }
  };

  const handleCancel = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleOpen(false);
  };

  const handleClose = () => {
    toggleOpen(false);
  };

  return (
    <Popover size="md" placement="auto" isOpen={isOpen} onClose={handleClose}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <Portal>
        <PopoverContent onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <PopoverHeader>Change active organization?</PopoverHeader>
          <PopoverBody>
            Changing your active organization will affect all tabs in your
            browser.
          </PopoverBody>
          <PopoverFooter>
            <PopoverButtonGroup>
              <Button variant="secondary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                isDisabled={!requestedGroupMember}
                onClick={handleSwitchAndRedirect}
              >
                Confirm
              </Button>
            </PopoverButtonGroup>
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default ActionSwitchGroupPopover;
